import { render, staticRenderFns } from "./RightHeader.vue?vue&type=template&id=38e1de82&scoped=true&"
import script from "./RightHeader.vue?vue&type=script&lang=js&"
export * from "./RightHeader.vue?vue&type=script&lang=js&"
import style0 from "./RightHeader.vue?vue&type=style&index=0&id=38e1de82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1de82",
  null
  
)

export default component.exports